var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","font-size":"24px","margin-top":"50px"}},[_vm._v("页面离家出走了......")])
}
var staticRenderFns = []

export { render, staticRenderFns }